import React, { useContext, useEffect, useState } from 'react'
import { ThemeContext } from '../../../../../auth';
import Swal from 'sweetalert2';
import { Button, Form, Modal, Spinner } from 'react-bootstrap';
import Select from 'react-select';
import { axiosAuth } from '../../../../../api';

function ModalTambahDivisi({
    showTambahDivisi,
    setShowTambahDivisi,
    retrieveDivisi,
    accessToken,
    retrieveRole
}) {
    const { theme } = useContext(ThemeContext);
    const [listMenu, setListMenu] = useState([]);
    const [divisiName, setDivisiName] = useState('');
    const [selectedMenu, setSelectedMenu] = useState([]);
    const [disabled, setDisabled] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleClose = () => {
        setShowTambahDivisi(false);
        setDivisiName('');
        setSelectedMenu([]);
    };

    const retrieveMenu = () => {
        axiosAuth.get(`/api/menus`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`,
                },

            })
            .then(res => {

                setListMenu(res.data.data);

            }).catch(err => {

                console.error(err)
            })
    };

    useEffect(() => {
        if (accessToken !== undefined) retrieveMenu();
    }, [accessToken]);

    const menuOptions = listMenu.map(menu => ({
        value: menu.id,
        label: menu.menuName,
    }));

    const handleSelectMenu = selectedOption => {
        setSelectedMenu(selectedOption);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsSubmitting(true);
        const dataDivisi = {
            groupName: divisiName,
        };
        setDisabled(true);

        try {

            const responseDivisi = await axiosAuth.post(`/api/groups`, dataDivisi, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            handleClose();
            Swal.fire({
                icon: 'success',
                title: 'Berhasil menambahkan Divisi',
                showConfirmButton: true,
            });
            retrieveDivisi();
            retrieveRole();
            setIsSubmitting(false);
            setDisabled(false);

        } catch (err) {
            console.error(err);
            if (err.response?.status === 400) {

                Swal.fire({
                    icon: 'error',
                    title: 'Oops...!',
                    text: `${err.response?.data}`,
                })
                setIsSubmitting(false);
                setDisabled(false);

            } else {

                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Terjadi kesalahan saat menambahkan Divisi',
                });

            };
            setIsSubmitting(false);
            setDisabled(false);

        } finally {

            setIsSubmitting(false);
            setDisabled(false);

        }
    };

    const formStyles = {
        label: {
            fontFamily: 'Poppins-Medium',
            color: theme === 'light' ? '#FFFFFF' : '#222222',
        },
        input: {
            color: theme === 'light' ? '#FFFFFF' : '#222222',
            fontFamily: 'Poppins-Regular',
            minHeight: '50px',
            borderColor: '#ced4da',
        },
    };

    const selectStyles = {
        control: (provided, state) => ({
            ...provided,
            minHeight: '50px',
            border: state.isFocused ? '1px solid #80bdff' : '1px solid #ced4da',
            background: theme === 'light' ? '#212529' : '#FFFFFF',
            boxShadow: state.isFocused ? '0 0 0 0.3rem rgba(0, 123, 255, 0.25)' : null,
            '&:hover': {
                borderColor: '#80bdff',
            },
            fontFamily: 'Poppins-Regular'
        }),
        singleValue: (provided, state) => ({
            ...provided,
            color: theme === 'light' ? (state.isFocused ? 'red' : 'white') : (state.isFocused ? 'red' : '#222'),
        }),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected ? '#fff' : '#333',
            background: state.isSelected ? '#007bff' : '#fff',
            fontFamily: 'Poppins-Regular'
        }),
    };

    return (
        <Modal
            show={showTambahDivisi}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            centered
            data-bs-theme={theme === 'light' ? 'dark' : ''}
        >
            <Modal.Header closeButton >
                <Modal.Title style={{ fontFamily: 'Poppins-Medium', color: theme === 'light' ? '#FFFFFF' : '#222222' }}>
                    Tambah Divisi
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                        <Form.Label style={formStyles.label} htmlFor='divisiName'>Nama Divisi*</Form.Label>
                        <Form.Control
                            id='divisiName'
                            type="text"
                            onChange={(e) => setDivisiName(e.target.value)}
                            value={divisiName}
                            required
                            placeholder="Masukkan nama divisi"
                            style={formStyles.input}
                        />
                    </Form.Group>
                    {/* <Form.Group className="mb-3">
                        <Form.Label style={formStyles.label} htmlFor='groupMenu'>Akses Menu*</Form.Label>
                        <Select
                            isMulti
                            name="groupMenu"
                            options={menuOptions}
                            value={selectedMenu}
                            onChange={handleSelectMenu}
                            styles={selectStyles}
                            placeholder="Pilih akses menu"
                        />
                    </Form.Group> */}
                    <div className="d-grid gap-2 mt-4">
                        {isSubmitting ? (
                            <Button
                                id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                variant='btn'
                                disabled
                            >
                                <Spinner
                                    animation="border"
                                    size='sm'
                                />
                            </Button>
                        ) : (
                            <Button
                                type="submit"
                                id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                variant='btn'
                                disabled={
                                    disabled ||
                                    !divisiName ||
                                    !selectedMenu
                                }
                            >
                                Simpan
                            </Button>
                        )}
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    )
}

export default ModalTambahDivisi
